import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getFeedbackDetailStart,
  getFeedbackDetailSuccess,
  getFeedbackDetailFailed,
} from "../redux/getFeedbackDetail";
import { getFeedbackDetailAPI } from "core/http/service/decleareLeave";

import { toast } from "react-toastify";
import { ErrorMessage } from "core/http/service/decleareLeave/const";

function* getFeedbackDetailWork(action) {
  const { screenCode, id, callback } = action.payload;

  try {
    const res = yield call(getFeedbackDetailAPI, {
      screenCode,
      id,
    });

    yield put({
      type: getFeedbackDetailSuccess.type,
      payload: res,
    });
    if (callback) {
      callback(res);
    }
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: getFeedbackDetailFailed.type,
      payload: ErrorMessage[error?.response?.data?.code] ?? "Có lỗi xảy ra",
    });
  }
}

function* watchGetFeedbackDetail() {
  yield takeLatest(getFeedbackDetailStart.type, getFeedbackDetailWork);
}

export default function* getArriveLateDetailSaga() {
  yield all([watchGetFeedbackDetail()]);
}
